/* eslint-disable react/display-name */
import React, { useState, useContext } from 'react'
import { Modal, Input, message } from 'antd'
import { ErrorContext } from 'context'
import { renameRole } from 'api/pgads'

export default ({ visible, hide, targetInfo, id, dataMap }) => {
  const [newRoleName, setNewRoleName] = useState('')
  const { setError } = useContext(ErrorContext)
  return (
    <Modal
      visible={visible !== undefined}
      okText="Save"
      centered
      title="Rename Role Name"
      width={500}
      height={400}
      onOk={() => {
        if (newRoleName.trim().length <= 0) {
          message.error('Please, Provide new name for the Role')
          return
        }

        const dup = Object.values(dataMap).find(
          d => d.displayName === newRoleName
        )
        if (dup) {
          message.error('Role Name already used.Please provide another name.')
          return
        }
        renameRole(
          targetInfo,
          dataMap[id].map(d => d.id),
          newRoleName
        ).fork(setError, () => hide(true))
        // hide()
      }}
      onCancel={() => hide(false)}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 300px',
          gridGap: '10px',
        }}
      >
        <div style={{ display: 'grid', alignContent: 'center' }}>
          Old Role Name
        </div>
        <Input value={dataMap[id][0].displayName} disabled />
        <div style={{ display: 'grid', alignContent: 'center' }}>
          New Role Name
        </div>
        <Input
          value={newRoleName}
          max={100}
          onChange={e => setNewRoleName(e.target.value)}
          placeholder={visible}
        />
      </div>
    </Modal>
  )
}
